import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useMouseHelper } from './useMouseHelper';
// import '../css/TestimonialsSlider.css';

const TestimonialsSlider = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const {
    handleMouseEnter,
    handleMouseLeave,
    handleMouseDown,
    handleMouseUp
  } = useMouseHelper();
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      const prevBtn = sliderRef.current.querySelector('.swiper-button-prev');
      const nextBtn = sliderRef.current.querySelector('.swiper-button-next');

      if (prevBtn) {
        prevBtn.setAttribute('data-mouse-helper', 'hover');
        prevBtn.setAttribute('data-mouse-helper-text', 'Previous');
      }

      if (nextBtn) {
        nextBtn.setAttribute('data-mouse-helper', 'hover');
        nextBtn.setAttribute('data-mouse-helper-text', 'Next');
      }
    }
  }, []);
  const testimonials = [
    {
      id: 1,
      name: "Fatima Al-Zahra",
      role: "Owner,Fresh Foods Wholesalers",
      content: `Oman’s food self-sufficiency reached about 65.8% in 2024, driven by growth in local farming and fisheries. Golden Agriculture supports this mission through reliable grain sourcing and supply solutions.`,
      image: "/img/comment/1.jpg"
    },
    {
      id: 2,
      name: "Faisal",
      role: "Distributor, Al Noor Trading",
      content: `The agriculture and fisheries sector grew over 9% recently, showing Oman’s focus on food security. Golden Agriculture plays a role in strengthening this progress.`,
      image: "/img/comment/2.jpg"
    },
    {
      id: 3,
      name: "Abdullah",
      role: "Procurement Manager, Global Supply Chain Ltd.",
      content: `Oman is 97% self-sufficient in fresh milk and 140% in fish, but crop output still lags. Golden Agriculture helps balance the gap through imports and distribution.`,
      image: "/img/comment/3.jpg"
    },
    {
      id: 4,
      name: "Ali",
      role: "Director, Food Horizons Company",
      content: `Oman’s food market is valued at over OMR 2.7 billion annually, highlighting strong consumer demand—where Golden Agriculture remains a trusted supplier.`,
      image: "/img/comment/4.jpg"
    },
    {
      id: 5,
      name: "Omar Al-Harthy",
      role: "Operations Head, Al Baraka Exports",
      content: `Under Oman Vision 2040, the country is investing heavily in agriculture to boost food security. Golden Agriculture aligns its strategy to support these national goals.`,
      image: "/img/comment/1.jpg"
    }
  ];

  return (
    <section className="elementor-section elementor-top-section elementor-element elementor-element-75e9b3b elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static" style={{ display: "flex", justifyContent: "center" }}>
      <div className="elementor-containerelementor-container elementor-column-gap-extended">
        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5b83564 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-d82b984 sc_fly_static elementor-widget elementor-widget-trx_sc_testimonials">
              <div className="elementor-widget-container">
                <div className='sc_testimonials sc_testimonials_alter'>
                  {/* Autoplay */}
                  <h2 className="sc_item_title sc_title_title sc_align_center sc_item_title_style_default sc_item_title_tag" onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}><span className="sc_item_title_text">Your Export-Ready Partner from Oman to the World</span></h2>

                  <div className='sc_testimonials_slider sc_item_slider slider_swiper_outer slider_outer slider_outer_controls slider_outer_controls_side slider_outer_pagination slider_outer_pagination_bullets slider_outer_pagination_pos_bottom slider_outer_nocentered slider_outer_overflow_hidden slider_outer_one'>
                    <div
                      data-slides-per-view-breakpoints="{&quot;999999&quot;:1}"
                      data-slides-space-breakpoints="{&quot;999999&quot;:30}"
                      className="slider_container swiper-slider-container slider_swiper slider_noresize slider_controls slider_controls_side slider_pagination slider_pagination_bullets slider_pagination_pos_bottom slider_nocentered slider_overflow_hidden slider_one go swiper_c2c7799 inited swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
                      data-slides-space="30" data-effect="slide"
                      data-slides-min-width="290" data-pagination="bullets"
                      data-direction="horizontal" data-mouse-wheel="0"
                      data-autoplay="0" data-loop="1" data-free-mode="0"
                      data-slides-centered="0" data-slides-overflow="0"
                      data-mouse-helper-hide-cursor="0" data-mouse-helper="hover"
                       data-mouse-helper-centered="1" data-mouse-helper-magnet="0"
                      data-mouse-helper-bg-color="rgba(0, 0, 0, 1)"
                      data-mouse-helper-mode="normal" data-mouse-helper-axis="xy" 
                      data-mouse-helper-delay="8" data-mouse-helper-text-round="0"
                      data-mouse-helper-layout="&lt;div class=custom-helper&gt;&lt;span&gt;&lt;/span&gt;&lt;/div&gt;" id="swiper_c2c7799"
                      data-busy="0"
                      ref={sliderRef}
                      style={{ display: "block", opacity: 1 }}
                      onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                      >
                      <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={isMobile ? 15 : 30}
                        slidesPerView={1}
                        navigation={{
                          nextEl: '.swiper-button-next',
                          prevEl: '.swiper-button-prev',
                        }}
                        pagination={{
                          el: '.swiper-pagination',
                          clickable: true,
                        }}
                        autoplay={{
                          delay: 5000,
                          disableOnInteraction: false,
                        }}
                        loop={true}
                        className="sc_testimonials_slider sc_item_slider"
                      >
                        {testimonials.map(testimonial => (
                          <SwiperSlide key={testimonial.id}>
                            <div className="sc_testimonials_item sc_item_container"
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              onMouseDown={handleMouseDown}
                              onMouseUp={handleMouseUp}
                            >
                              <div className="sc_testimonials_item_top">
                                <div className="sc_testimonials_item_author_avatar">
                                  {/* <img
                              src={testimonial.image}
                              alt={testimonial.name}
                            
                              style={{ objectFit: "cover", width: "100%", height: "100%"}}
                            /> */}
                                </div>
                              </div>
                              <div className="sc_testimonials_item_content text-center">
                                <p className="mx-auto px-4" style={{ maxWidth: "700px" }}>
                                  {testimonial.content}
                                </p>
                              </div>
                              <div className='d-flex justify-content-center sc_testimonials_item_author2 mt-3'><i className="fa-solid fa-quote-left"> </i>   </div>
                              <div className="sc_testimonials_item_author1">



                                {/* <div className="sc_testimonials_item_author_data">
                            <h4 className="sc_testimonials_item_author_title" style={{color:"#000"}}>
                              {testimonial.name}
                            </h4>
                            <div className="sc_testimonials_item_author_subtitle" style={{color:"#615d58"}}>
                              {testimonial.role}
                            </div>
                          </div> */}
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}

                        <div className="slider_controls_wrap">
                          <div className="swiper-button-prev"
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onMouseDown={handleMouseDown}
                            onMouseUp={handleMouseUp}></div>
                          <div className="swiper-button-next"
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            onMouseDown={handleMouseDown}
                            onMouseUp={handleMouseUp}
                          ></div>
                        </div>
                        <div className="slider_controls_wrap">
                          <a className="slider_prev swiper-button-prev" href="#" role="button" tabindex="0" aria-label="Previous slide" aria-controls="swiper-wrapper-521043262778107fea"></a>
                          <a className="slider_next swiper-button-next" href="#" role="button" tabindex="0" aria-label="Next slide" aria-controls="swiper-wrapper-521043262778107fea"></a>
                        </div>
                        <div className="slider_pagination_wrap">
                          <div className="swiper-pagination"></div>
                        </div>
                      </Swiper>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSlider;